import {Module} from '@fantasmagames/slot/src/common/Module';
import {StatisticsWindowView} from '@fantasmagames/slot/src/modules/statistics/StatisticsWindowView';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';

/**
 * statistics window module
 * used for debug and telemetry purposes
 */
export class StatisticsWindowModule extends Module<StatisticsWindowView> {
	protected enterFirstState(): void {
	}

	protected setupStates(): void {
	}

	protected setupViews(): void {
		this.setView(Views.STATISTICS_WINDOW_VIEW);
	}

	protected setupEvents(): void {
		super.setupEvents();

		document.addEventListener('keydown', this.keyboardInput.bind(this));

		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
	}

	protected onSpinStarted(): void {
		this.view.spinMade();
		this.view.moneySpent(this.logic.getTotalBet());
	}

	protected onCanSpin(): void {
		this.view.moneyWon(this.logic.getWin());
	}

	private keyboardInput(event: KeyboardEvent): void {
		if (event.code === 'Backquote') {
			this.view.toggleView();
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/statistics/StatisticsWindowModule.ts